import { ActionTree } from "vuex";
import axios, { AxiosResponse } from "axios";
import { RootState } from "@/store/types";
import {
  IncomingTariffsFilterParams,
  IncomingTariffsItem,
  IncomingTariffsItemInfo,
  IncomingTariffsState,
} from "./types";

export const actions: ActionTree<IncomingTariffsState, RootState> = {
  async getIncomingTariffs(
    { commit },
    data: { filter: IncomingTariffsFilterParams; transport: string }
  ) {
    commit("setLoading", true);
    try {
      let resp: AxiosResponse<{ routes: IncomingTariffsItem[] }> = await axios({
        url: `/acapi/${data.transport.toLowerCase()}/incoming/tariffs`,
        params: data.filter ? data.filter : null,
      });
      commit("setIncomingTariffs", resp.data.routes);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getIncomingTariffsInfo(
    { commit },
    data: { id: string; transport: string }
  ) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<IncomingTariffsItemInfo> = await axios({
        url: `/acapi/${data.transport.toLowerCase()}/incoming/tariffs/${encodeURIComponent(
          data.id
        )}`,
      });
      return resp.data;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async saveIncomingTariff(
    { commit, dispatch },
    data: { tariff: IncomingTariffsItemInfo; transport: string }
  ) {
    commit("setLoading", true);
    try {
      console.log(data);
      const resp: AxiosResponse<{ status: string }> = await axios({
        method: data.tariff?.id ? "PUT" : "POST",
        url: `/acapi/${data.transport?.toLowerCase()}/incoming/tariffs/${data.tariff?.id ?? ""}`,
        data: data.tariff,
      });
      dispatch("getIncomingTariffs");
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async deleteIncomingTariff(
    { commit, dispatch },
    data: { tariff: IncomingTariffsItemInfo; transport: string }
  ) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{ status: string }> = await axios({
        method: "DELETE",
        url: `/acapi/${data.transport?.toLowerCase()}/incoming/tariffs/${data.tariff.id}`,
        data: data.tariff,
      });
      dispatch("getIncomingTariffs");
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
};
